import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import {
  $deposit,
  $amount,
  depositMounted,
  getDeposit,
  $clientPurses,
  $success,
  $error,
  $dividendBalance,
  $instalmentItem,
  getInstalments,
  submitDepositStatus,
  rejectDeposit,
  rollbackDeposit,
} from './model'

export const useDeposit = () => {
  const { pathname } = useLocation()
  const deposit = useStore($deposit)
  const loading = useStore(getDeposit.pending)
  const statusChanging = useStore(submitDepositStatus.pending)
  const rejecting = useStore(rejectDeposit.pending)
  const rollingBack = useStore(rollbackDeposit.pending)
  const instalmentLoading = useStore(getInstalments.pending)
  const amountVisited = useStore($amount)
  const clientPurses = useStore($clientPurses)
  const error = useStore($error)
  const success = useStore($success)
  const dividendBalance = useStore($dividendBalance)
  const instalmentItem = useStore($instalmentItem)

  const actionLoading = statusChanging || rejecting || rollingBack

  React.useEffect(() => {
    depositMounted()
  }, [pathname])

  return {
    deposit,
    amountVisited,
    clientPurses,
    loading,
    actionLoading,
    error,
    success,
    dividendBalance,
    instalmentItem,
    instalmentLoading,
  }
}
